import React from "react";
import styled from "styled-components";
import Toggle from "../../../../core/components/CollapsToggle/Toggle";
import { useRecoilState } from "recoil";
import { ContentUnitModal } from "../../../../shared/content-unit";
import BrandGenerator from "./BrandGenerator";
import BrandTable from "./BrandTable";
import DeleteBrand from "../../../Dialog/contentUnit/productCategory/DeleteBrand";
import EditBrand from "../../../Dialog/contentUnit/productCategory/EditBrand";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

function AddBrand() {
  const [modualsContent, setModuals] = useRecoilState(ContentUnitModal);

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="دسته بندی محصولات"
        num3="افزودن برند"
        href1="/dashboard/content-controller"
        href2="/dashboard/productCategory"
      />
      <BrandStyle>
        {modualsContent.deleteBrand.isShow && (
          <DeleteBrand
            show={modualsContent.deleteBrand.isShow}
            handleClose={() =>
              setModuals({
                ...modualsContent,
                deleteBrand: {
                  ...modualsContent.deleteBrand,
                  isShow: false,
                },
              })
            }
          />
        )}
        {modualsContent.updateBrand.isShow && (
          <EditBrand
            show={modualsContent.updateBrand.isShow}
            handleClose={() =>
              setModuals({
                ...modualsContent,
                updateBrand: {
                  ...modualsContent.updateBrand,
                  isShow: false,
                },
              })
            }
          />
        )}
        <Toggle title={"افزودن برند"}>
          <BrandGenerator />
        </Toggle>
        <BrandTable />
      </BrandStyle>
    </>
  );
}

const BrandStyle = styled.div``;

export default AddBrand;
